import React from "react";
import {
  Porting,
  PSTNCloud,
  InboundCloud,
  MeetAudio,
  XSeries,
  HardPhones,
  ProductSupport,
  LNPDetails,
  NumberingDetails,
  HorizontalHeader,
  HorizontalColumn,
  HorizontalValue,
} from "@/react/features/globalization/components/cell-renders";
import { color } from "@8x8/oxygen-constants";
import styled from "styled-components";

const MainContainer = styled.div`
  padding: 16px;
  background-color: ${color.cloudyBlue100};
`;

const ColumnContainer = styled.div`
  display: flex;
  gap: 15px;
`;

const MarginTopContainer = styled.div`
  margin-top: 16px;
`;

export const ExpandedRow = (props) => {
  return (
    <MainContainer>
      <ColumnContainer>
        <HorizontalColumn>
          <HorizontalHeader>PSTN Cloud</HorizontalHeader>
          <HorizontalValue>
            <PSTNCloud row={props.row.row.original} />
          </HorizontalValue>
        </HorizontalColumn>
        <HorizontalColumn>
          <HorizontalHeader>Inbound Cloud</HorizontalHeader>
          <HorizontalValue>
            <InboundCloud row={props.row.row.original} />
          </HorizontalValue>
        </HorizontalColumn>
        <HorizontalColumn>
          <HorizontalHeader>Porting</HorizontalHeader>
          <HorizontalValue>
            <Porting row={props.row.row.original} />
          </HorizontalValue>
        </HorizontalColumn>
        <HorizontalColumn>
          <HorizontalHeader>X Series</HorizontalHeader>
          <HorizontalValue>
            <XSeries row={props.row.row.original} />
          </HorizontalValue>
        </HorizontalColumn>
      </ColumnContainer>
      <hr />
      <ColumnContainer>
        <HorizontalColumn>
          <HorizontalHeader>8x8 Meet Audio</HorizontalHeader>
          <HorizontalValue>
            <MeetAudio row={props.row.row.original} />
          </HorizontalValue>
        </HorizontalColumn>
        <HorizontalColumn>
          <HorizontalHeader>Product Support</HorizontalHeader>
          <HorizontalValue>
            <ProductSupport row={props.row.row.original} />
          </HorizontalValue>
        </HorizontalColumn>
        <HorizontalColumn>
          <HorizontalHeader>Hard Phones</HorizontalHeader>
          <HorizontalValue>
            <HardPhones row={props.row.row.original} />
          </HorizontalValue>
        </HorizontalColumn>
      </ColumnContainer>
      <hr />
      <MarginTopContainer>
        <HorizontalHeader>LNP Details</HorizontalHeader>
        <LNPDetails row={props.row.row.original} isColumnDisplay />
        <hr />
        <HorizontalHeader>Numbering Details</HorizontalHeader>
        <NumberingDetails row={props.row.row.original} isColumnDisplay />
      </MarginTopContainer>
    </MainContainer>
  );
};
